/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_TitleInputs */

const en_us2_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite friends`)
};

const pt_br2_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar amigos`)
};

const pt_pt2_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar amigos`)
};

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const es_419_invite_title = en_us2_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const fr_fr2_invite_title = en_us2_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const de_de2_invite_title = en_us2_invite_title;

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const it_it2_invite_title = en_us2_invite_title;

/**
* | output |
* | --- |
* | "Invite friends" |
*
* @param {Invite_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_title = /** @type {((inputs?: Invite_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_title(inputs)
	if (locale === "es-419") return es_419_invite_title(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_title(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_title(inputs)
	if (locale === "de-DE") return de_de2_invite_title(inputs)
	if (locale === "it-IT") return it_it2_invite_title(inputs)
	return en_us2_invite_title(inputs)
});
export { invite_title as "invite.title" }